// Hero messages for the landing page
// These will cycle through to show different value propositions

export const HERO_MESSAGES = [
  {
    title: "The Only Home Service Plan You'll Ever Need.",
    subtitle: "Built for Bay Area homes, customized for your address. Type it in to start now."
  },
  {
    title: "One Monthly Bill. A Year of Maintenance.",
    subtitle: "Subscriptions designed for busy homeowners and landlords. Enter your address to see your plan."
  },
  {
    title: "Your Home, Always Ready.",
    subtitle: "Smart maintenance plans that keep your property spotless year-round. Start with your address now."
  },
  {
    title: "The Smarter Way to Maintain Your Home.",
    subtitle: "Custom exterior service packages built around your property. Enter your address to unlock your plan."
  },
  {
    title: "Your Home, Zero Maintenance Stress.",
    subtitle: "Predictable upkeep that saves time and money. Enter your address now."
  },
  {
    title: "End the Chore Cycle.",
    subtitle: "Weed pulling, mowing, trimming, cleaning — we handle it all. Start by entering your address."
  },
  {
    title: "From Gutters to Garden Beds. We've Got It.",
    subtitle: "Stop piecing together services. One subscription, everything handled. Enter your address."
  },
  {
    title: "Predictable Maintenance. Priceless Peace of Mind.",
    subtitle: "Affordable subscription packages for every home. Begin with your address today."
  },
  {
    title: "Because Homeownership Shouldn't Feel Like a Job.",
    subtitle: "Custom plans designed for Bay Area living. Enter your address to begin."
  },
  {
    title: "No More Last-Minute Handyman Calls.",
    subtitle: "Preventive care plans that keep surprises away. Start by entering your address."
  },
  {
    title: "Stop Wasting Weekends on Home Chores.",
    subtitle: "From mowing to gutters, we handle the dirty work. Enter your address to get a custom upkeep plan."
  },
  {
    title: "Exterior Services. Simplified.",
    subtitle: "Mowing, blowing, trimming, cleaning — bundled for less. Start with your address."
  },
  {
    title: "Never Argue About Yard Work Again.",
    subtitle: "Predictable home maintenance plans that keep peace at home. Enter your address now."
  },
  {
    title: "More Than Lawn Care. Total Exterior Protection.",
    subtitle: "Comprehensive plans for busy homeowners. Enter your address to begin."
  },
  {
    title: "Because Your Weekends Belong to You.",
    subtitle: "Let HammerSawPaint tackle the endless to-do list. Enter your address to begin."
  }
];

// Configuration for message cycling
export const MESSAGE_CONFIG = {
  // Time in milliseconds between message changes
  CYCLE_INTERVAL: 6000,
  // Animation duration for transitions
  TRANSITION_DURATION: 800,
  // Whether to start cycling automatically
  AUTO_CYCLE: true
};
